// src/public/rsvp/parts/RightsAccordion.jsx
import React from 'react';
import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import Icon from '@mui/material/Icon';
import { alpha } from '@mui/material/styles';

import MDBox from 'components/MDBox';
import MDTypography from 'components/MDTypography';
import { safeText, fmtDateTR } from '../utils/rsvpFormatters';
import { compactAccordionSx, compactTitleSx, compactSubSx, compactRowSx } from './rsvpCompactSx';

export function RightsAccordion({ remainingRights, lastSessions }) {
  const rows = (lastSessions || []).slice(0, 6);

  return (
    <Accordion sx={compactAccordionSx}>
      <AccordionSummary expandIcon={<Icon sx={{ fontSize: 18 }}>expand_more</Icon>}>
        <MDBox sx={{ minWidth: 0 }}>
          <MDTypography sx={compactTitleSx}>Kalan Hak</MDTypography>
          <MDTypography sx={compactSubSx}>
            {remainingRights?.remaining ?? '—'} hak • {safeText(remainingRights?.planName, '—')}
          </MDTypography>
        </MDBox>
      </AccordionSummary>

      <AccordionDetails>
        <MDBox display="grid" gap={0.35}>
          <MDTypography sx={compactRowSx}>
            <b>Kalan:</b> {remainingRights?.remaining ?? '—'}
          </MDTypography>
          <MDTypography sx={compactRowSx}>
            <b>Paket:</b> {safeText(remainingRights?.planName)}
          </MDTypography>

          <MDBox mt={0.6}>
            <MDTypography sx={{ fontSize: 11.5, opacity: 0.68, fontWeight: 800 }}>
              Son seanslar
            </MDTypography>

            <MDBox
              mt={0.45}
              sx={(t) => ({
                borderRadius: 6,
                border: `1px solid ${
                  t.palette.mode === 'dark'
                    ? alpha(t.palette.common.white, 0.08)
                    : alpha(t.palette.common.black, 0.06)
                }`,
                background:
                  t.palette.mode === 'dark'
                    ? alpha(t.palette.common.white, 0.03)
                    : alpha(t.palette.common.black, 0.02),
                overflow: 'hidden',
              })}
            >
              {rows.length ? (
                rows.map((x, idx) => (
                  <MDBox
                    key={idx}
                    sx={(t) => ({
                      px: 0.75,
                      py: 0.6,
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'space-between',
                      gap: 1,
                      borderTop:
                        idx === 0
                          ? 'none'
                          : `1px solid ${
                              t.palette.mode === 'dark'
                                ? alpha(t.palette.common.white, 0.08)
                                : alpha(t.palette.common.black, 0.06)
                            }`,
                    })}
                  >
                    <MDTypography sx={{ fontSize: 12, opacity: 0.85, fontWeight: 700 }} noWrap>
                      {fmtDateTR(x?.startAt)}
                    </MDTypography>
                    <MDTypography sx={{ fontSize: 12, opacity: 0.75 }} noWrap>
                      {safeText(x?.trainerName)}
                    </MDTypography>
                    <MDTypography sx={{ fontSize: 12, opacity: 0.8, fontWeight: 800 }} noWrap>
                      {safeText(x?.status)}
                    </MDTypography>
                  </MDBox>
                ))
              ) : (
                <MDTypography sx={{ fontSize: 12, opacity: 0.65, px: 0.75, py: 0.7 }}>
                  Kayıt yok.
                </MDTypography>
              )}
            </MDBox>
          </MDBox>
        </MDBox>
      </AccordionDetails>
    </Accordion>
  );
}
